export default __webpack_public_path__ + "17f441c.png";